export default __webpack_public_path__ + "acc52394957d2553f95c441093862a35.svg";